module.exports = __webpack_public_path__ + "static/media/loghi fami.c964ef0d.svg";